export enum AssetDigitizationStatus {
  DIGITIZING = 'digitizing',
  DIGITIZED = 'digitized',
  FAILED = 'failed',
}
